import { render, staticRenderFns } from "./MapCharacterLayer.vue?vue&type=template&id=b80ac7ca&scoped=true&lang=pug&"
import script from "./MapCharacterLayer.vue?vue&type=script&lang=js&"
export * from "./MapCharacterLayer.vue?vue&type=script&lang=js&"
import style0 from "./MapCharacterLayer.vue?vue&type=style&index=0&id=b80ac7ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80ac7ca",
  null
  
)

component.options.__file = "MapCharacterLayer.vue"
export default component.exports